import React, { useState } from "react";
import Validator from "validatorjs";

import './styles.css';
import SimpleCardForm from "./SimpleCardForm";

const ManageCardForm = (props) => {
  const [data, setData] = useState({save_card: true});

  const rules = {
    card_number: ['required', 'card_number'],
    card_expiration: ['required', 'card_expiration'],
    card_cvc: ['required', 'card_cvc'],
  }

  const handleOnChange = (event) => {
    const newData = {
      ...data,
      ...event
    }

    setData(newData)

    const validator = new Validator(newData, rules);

    validator.check();

    props.onChange({
      isValid: validator.passes(),
      payment: () => {
        return {
          error: undefined,
          payment: {
            card: newData
          }
        }
      },
      data: newData
    })
  }

  return (
    <>
      <SimpleCardForm
        data={ data }
        rules={ rules }
        onChange={ handleOnChange }
      />
    </>
  );
};

export default ManageCardForm;
